@if (display() === 'show') {
    <a routerLink="/">
        <img src="quorum-logo_light.png" class="h-10 w-auto dark:hidden">
        <img src="quorum-logo_dark.png" class="h-10 w-auto hidden dark:block">
    </a>
}
@else {
    <img src="quorum-logo_light.png" class="h-10 w-auto opacity-0 dark:hidden">
    <img src="quorum-logo_dark.png" class="h-10 w-auto opacity-0 hidden dark:block">
}

